import React from 'react';
import PropTypes from 'prop-types';

const Shop = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 19.127V14.127C13 13.5747 12.5523 13.127 12 13.127H9C8.44772 13.127 8 13.5747 8 14.127V19.127"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 9.12695V15.127C3.5 17.0126 3.5 17.9554 4.08579 18.5412C4.67157 19.127 5.61438 19.127 7.5 19.127H13.5C15.3856 19.127 16.3284 19.127 16.9142 18.5412C17.5 17.9554 17.5 17.0126 17.5 15.127V9.12695"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M3.12127 2.64188C3.30316 1.91432 3.3941 1.55054 3.66536 1.33875C3.93663 1.12695 4.3116 1.12695 5.06155 1.12695H15.9384C16.6884 1.12695 17.0634 1.12695 17.3346 1.33875C17.6059 1.55054 17.6968 1.91432 17.8787 2.64188L19.0823 7.45633C19.1792 7.84371 19.2276 8.03739 19.2169 8.19471C19.1892 8.60264 18.916 8.95262 18.5269 9.07843C18.3769 9.12695 18.1726 9.12695 17.7641 9.12695V9.12695C17.2309 9.12695 16.9644 9.12695 16.7405 9.0748C16.1133 8.92868 15.5948 8.48945 15.3475 7.89477C15.2593 7.6825 15.2164 7.42551 15.1308 6.91152V6.91152C15.1068 6.76771 15.0948 6.69581 15.0812 6.67689C15.0413 6.62134 14.9587 6.62134 14.9188 6.67689C14.9052 6.69581 14.8932 6.76771 14.8692 6.91152L14.7877 7.40076C14.7791 7.45263 14.7747 7.47856 14.7704 7.50128C14.5939 8.42746 13.7946 9.10462 12.852 9.12642C12.8289 9.12695 12.8026 9.12695 12.75 9.12695V9.12695C12.6974 9.12695 12.6711 9.12695 12.648 9.12642C11.7054 9.10462 10.9061 8.42746 10.7296 7.50128C10.7253 7.47856 10.7209 7.45263 10.7123 7.40076L10.6308 6.91152C10.6068 6.76771 10.5948 6.69581 10.5812 6.67689C10.5413 6.62134 10.4587 6.62134 10.4188 6.67689C10.4052 6.69581 10.3932 6.76771 10.3692 6.91152L10.2877 7.40076C10.2791 7.45263 10.2747 7.47856 10.2704 7.50128C10.0939 8.42746 9.29459 9.10462 8.35199 9.12642C8.32887 9.12695 8.30258 9.12695 8.25 9.12695V9.12695C8.19742 9.12695 8.17113 9.12695 8.14801 9.12642C7.20541 9.10462 6.40606 8.42746 6.2296 7.50128C6.22527 7.47856 6.22095 7.45263 6.2123 7.40076L6.13076 6.91152C6.10679 6.76771 6.09481 6.69581 6.08122 6.67689C6.04132 6.62134 5.95868 6.62134 5.91878 6.67689C5.90519 6.69581 5.89321 6.76771 5.86924 6.91152V6.91152C5.78357 7.42551 5.74074 7.6825 5.65249 7.89477C5.40524 8.48945 4.88675 8.92868 4.25951 9.0748C4.03563 9.12695 3.76905 9.12695 3.23591 9.12695V9.12695C2.82737 9.12695 2.62309 9.12695 2.47306 9.07843C2.08403 8.95262 1.81078 8.60264 1.78307 8.19471C1.77239 8.03739 1.82081 7.84371 1.91765 7.45633L3.12127 2.64188Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

Shop.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Shop;
